import { render, staticRenderFns } from "./downloader.vue?vue&type=template&id=56f8c779&"
import script from "./downloader.vue?vue&type=script&lang=js&"
export * from "./downloader.vue?vue&type=script&lang=js&"
import style0 from "./downloader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports